// extracted by mini-css-extract-plugin
export default {"controls":"video-layout_controls__dqM30","controlsGroup":"video-layout_controlsGroup__enxcC","spacer":"video-layout_spacer__6BUyh","gesture":"video-layout_gesture__SWrfu"};